import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=1f459a17&scoped=true"
import script from "./UserDrawer.vue?vue&type=script&lang=js"
export * from "./UserDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserDrawer.vue?vue&type=style&index=0&id=1f459a17&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f459a17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f459a17')) {
      api.createRecord('1f459a17', component.options)
    } else {
      api.reload('1f459a17', component.options)
    }
    module.hot.accept("./UserDrawer.vue?vue&type=template&id=1f459a17&scoped=true", function () {
      api.rerender('1f459a17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/components/UserDrawer.vue"
export default component.exports